import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE_PERFORMANCE_NETWORK_OVERVIEW = `${config.API_URL}Beacon4PerformanceNetworkOverview`;

export const GetBeacon4PerformanceNetworkOverviewDashboard = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_PERFORMANCE_NETWORK_OVERVIEW}/GetDashboardSeries`, data });

// Aggregation Mode table (rows = group dimension values, columns = dates)
export const GetBeacon4PerformanceNetworkOverviewTable = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_PERFORMANCE_NETWORK_OVERVIEW}/GetAggregationTable`, data });

// Returns { techs: [...], kpisByTech: { '2G': [{key, label}], ... } }
export const GetBeacon4PerformanceNetworkOverviewAvailableKpis = () =>
	AxiosRequest({ method: 'GET', url: `${BASE_PERFORMANCE_NETWORK_OVERVIEW}/GetAvailableKpis` });

// Side/Polygon/Vendor/JV ID options scoped to the selected Tech+KPI's source
// view and date range (Beacon4PerformanceNetworkOverview_filters_data).
// Returns { viewName, pairs: [{ side, polygon, vendor, jvId }, ...] }
export const GetBeacon4PerformanceNetworkOverviewFilters = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_PERFORMANCE_NETWORK_OVERVIEW}/GetFilters`, data });
